function wrapElement(element, wrapper) {
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
}

function appendElement(parent, child) {
    parent.appendChild(child);
}

function prependElement(parent, child) {
    if (parent.childNodes.length > 0) {
        parent.insertBefore(child, parent.childNodes[0]);
    }
    else {
        parent.appendChild(child);
    }
}

function createElement(tagName, parent) {
    const el = document.createElement(tagName);

    if (parent) {
        parent.appendChild(el);
    }

    return el;
}

function removeElement(element) {
    element.parentNode.removeChild(element);
}

function setStyles(element, styles) {
    for (let s in styles) {
        element.style[s] = styles[s];
    }
}

export { appendElement, prependElement, createElement, wrapElement, removeElement, setStyles };